import { makeAutoObservable, toJS } from "mobx";
import {
  toDisplayMonitoring,
  toDisplaySmileMate,
  toDisplaySummary,
} from "../utils/Utils";

class ResultsStore {
  data = {};
  symbol = "$";
  currency = "usd";
  numbersToTest = {
    w24: 0,
    w25: 0,
    w28: 0,
    w29: 0,
  };
  conditions = {
    separateTeensAdults: false,
    showHourly: false,
    separateStaffRole: false,
    smileMate: false,
    monitoringAligners: false,
    monitoringBraces: false,
  };
  indicators = {};
  numberClinics = 1;
  dso = true;
  step = 0;
  index = 0;
  steps = [];
  ids = [];
  name = "";
  doctorName = "";
  email = "";
  displayDetail = true;
  results = null;
  constructor() {
    makeAutoObservable(this);
  }

  setData(values) {
    this.name = values.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "clinicName")[0].value;
    this.dso = null != values.dso ? values.dso : true;
    this.numberClinics = values.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "numberClinics")[0].value;

    this.email = values.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "email")[0].value;
    this.doctorName = values.results
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((a) => a.fieldName == "doctorName")[0].value;
    this.data = values;
    this.setConditions(values.results);
    this.symbol = null != values.symbol ? values.symbol : "";
    this.currency = null != values.currency ? values.currency : "";
    this.setNumbersToTest(values.results);
    this.indicators = values.indicators;
    this.setIds(values);
    this.setSteps(values);
  }

  setResults(res) {
    this.results = res;
  }
  setDisplayDetail(value) {
    this.displayDetail = value;
  }

  setSteps() {
    var sum =
      this.numbersToTest.w24 +
      this.numbersToTest.w25 +
      this.numbersToTest.w28 +
      this.numbersToTest.w29;
    var l__steps = [];
    this.indicators.increaseLeads &&
      this.conditions.smileMate &&
      l__steps.push(0);
    this.indicators.increaseConversion &&
      this.conditions.smileMate &&
      l__steps.push(1);
    this.indicators.workLess && this.conditions.smileMate && l__steps.push(2);
    this.indicators.noriskTrying &&
      this.conditions.smileMate &&
      l__steps.push(3);

    this.indicators.dmSaves && sum > 0 && l__steps.push(4);
    this.indicators.workLessmonitoring && sum > 0 && l__steps.push(5);
    this.indicators.Increaseprofitability && sum > 0 && l__steps.push(6);
    this.indicators.introduceRetention && sum > 0 && l__steps.push(7);
    this.indicators.relapseRate && sum > 0 && l__steps.push(8);
    this.indicators.dashboard && l__steps.push(9);
    (this.indicators.workLesssummary || this.indicators.annualMargin) &&
      (this.conditions.monitoringAligners ||
        this.conditions.monitoringBraces) &&
      l__steps.push(10);
    this.step = l__steps[0];
    this.steps = l__steps;
  }
  setNumbersToTest(data) {
    var w24 = 0;
    var w25 = 0;
    var w28 = 0;
    var w29 = 0;

    data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((e) => e.fieldName == "general")[0]
      .value.filter((x) => {
        if (x.fieldName == "newAlignersTreatement") {
          w24 = x.value[0].value;
          w25 = x.value[1].value;
        }
        if (x.fieldName == "newBraces") {
          w28 = x.value[0].value;
          w29 = x.value[1].value;
        }
      });

    this.numbersToTest = {
      w24: parseFloat(w24) || 0,
      w25: parseFloat(w25) || 0,
      w28: parseFloat(w28) || 0,
      w29: parseFloat(w29) || 0,
    };
  }
  setConditions = (data) => {
    var newSeparateTeensAdults = false;
    data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.forEach((element) => {
        if (element.fieldName == "separateTeensAdults") {
          newSeparateTeensAdults = element.value;
        }
      });

    var newSeparateStaffRole = false;
    data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.forEach((element) => {
        if (element.fieldName == "separateRole") {
          newSeparateStaffRole = element.value;
        }
      });
    var newChangeShowHourly = false;
    data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.forEach((element) => {
        if (element.fieldName == "showHourly") {
          newChangeShowHourly = element.value;
        }
      });

    var newSmileMate = false;
    var newMonitoringAligners = false;
    var newMonitoringBraces = false;
    data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.forEach((element) => {
        if (element.fieldName == "products") {
          element.value.forEach((x) => {
            if (x.fieldName == "SmileMateFor") {
              newSmileMate = x.value;
            }
            if (x.fieldName == "monitoringFor") {
              newMonitoringAligners = x.value;
            }
            if (x.fieldName == "bracesFor") {
              newMonitoringBraces = x.value;
            }
          });
        }
      });

    var c = {};
    c.separateStaffRole = newSeparateStaffRole;

    c.separateTeensAdults = newSeparateTeensAdults;
    c.showHourly = newChangeShowHourly;
    c.smileMate = newSmileMate;
    c.monitoringAligners = newMonitoringAligners;
    c.monitoringBraces = newMonitoringBraces;
    this.conditions = c;
  };
  setIds(values) {
    this.ids = this.getIds(values);
  }
  setStep(pas) {
    this.index += pas;
    var l__step = this.steps[this.index];
    if (l__step > 8) {
      this.displayDetail = false;
    } else {
      this.displayDetail = true;
    }
    this.step = l__step;
  }
  setIndex(i) {
    this.index = i;
    var l__step = this.steps[this.index];
    if (l__step > 8) {
      this.displayDetail = false;
    } else {
      this.displayDetail = true;
    }
    this.step = l__step;
  }

  getIndexFirstSmileMate() {
    if (this.steps.includes(0)) {
      this.step = 0;
      this.index = this.steps.findIndex((e) => e == 0);
    } else if (this.steps.includes(1)) {
      this.step = 1;
      this.index = this.steps.findIndex((e) => e == 1);
    } else if (this.steps.includes(2)) {
      this.step = 2;
      this.index = this.steps.findIndex((e) => e == 2);
    } else if (this.steps.includes(3)) {
      this.index = this.steps.findIndex((e) => e == 3);

      this.step = 3;
    }
  }

  getIndexFirstMonitoring() {
    if (this.steps.includes(4)) {
      this.index = this.steps.findIndex((e) => e == 4);
      this.step = 4;
    } else if (this.steps.includes(5)) {
      this.index = this.steps.findIndex((e) => e == 5);

      this.step = 5;
    } else if (this.steps.includes(6)) {
      this.index = this.steps.findIndex((e) => e == 6);

      this.step = 6;
    } else if (this.steps.includes(7)) {
      this.index = this.steps.findIndex((e) => e == 7);

      this.step = 7;
    } else if (this.steps.includes(8)) {
      this.index = this.steps.findIndex((e) => e == 8);

      this.step = 8;
    }
  }

  getDashbordIndex() {
    if (this.steps.includes(9)) {
      this.displayDetail = false;
      this.index = this.steps.findIndex((e) => e == 9);
      this.step = 9;
    }
  }
  getSummaryndex() {
    if (this.steps.includes(10)) {
      this.displayDetail = false;
      this.index = this.steps.findIndex((e) => e == 10);
      this.step = 10;
    }
  }

  getIds(res) {
    var sum =
      this.numbersToTest.w24 +
      this.numbersToTest.w25 +
      this.numbersToTest.w28 +
      this.numbersToTest.w29;

    var l__ids = [];
    toDisplaySmileMate(res) && l__ids.push("smileMate");
    toDisplayMonitoring(res) && sum > 0 && l__ids.push("monitoring");
    res.indicators.dashboard && l__ids.push("dashboard");
    toDisplaySummary(res) &&
      (this.conditions.monitoringAligners ||
        this.conditions.monitoringBraces) &&
      l__ids.push("summary");
    return l__ids;
  }

  setDefaults() {
    this.data = {};
    this.numbersToTest = {
      w24: 0,
      w25: 0,
      w28: 0,
      w29: 0,
    };
    this.conditions = {
      separateTeensAdults: false,
      showHourly: false,
      separateStaffRole: false,
      smileMate: false,
      monitoringAligners: false,
      monitoringBraces: false,
    };
    this.indicators = {};
    this.step = 0;
    this.index = 0;
    this.steps = [];
    this.ids = [];
    this.name = "";
    this.displayDetail = true;
    this.results = null;
  }
}

export default new ResultsStore();
